import { DateTime } from 'luxon';
import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import { ClientReportItem } from 'modules/components/layer19';
import React from 'react';
import * as ds from './dataService';
import { ChipProps } from '@mui/material';
import _ from 'lodash';

export type ClientReportEventCardProps = {
  id: string;
  inspections: {
    id: string;
    inspectorName: string;
    systemInspected: string;
    notesForClient: string;
    inspectionStatus: string;
    updated: DateTime;
    isIncluded: boolean;
  }[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportEventCardProps) => {
  const [fnSaveInspection] = ds.useSaveClientReportEvent();
  return (
    <ActivityDetailSectionCardBaseLayout.FC
      title='Events'
      subTitle='List of Events that have occurred since the last Client Report.'
      actionButton={null}
      editActionButton={null}
    >
      {props.inspections.map((node) => (
        <ClientReportItem.FC
          key={node.id}
          id={node.id}
          handleInclude={() => {
            fnSaveInspection({
              id: node.id,
              included: !node.isIncluded
            });
          }}
          clientNotes={node.notesForClient}
          title={node.systemInspected}
          included={node.isIncluded}
          imageRow={null}
          status={{
            variant: node.inspectionStatus as ChipProps['variant'],
            label: _.upperFirst(node.inspectionStatus)
          }}
          secondaryBox={{
            label: 'Inspected By',
            value: node.inspectorName
          }}
          reportItemType='INSPECTION'
        />
      ))}
    </ActivityDetailSectionCardBaseLayout.FC>
  );
};
